var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.344,
    height: 100,
    viewBox: "0 0 74.344 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.129,100H15.215A15.215,15.215,0,0,1,0,84.785V15.215A15.215,15.215,0,0,1,15.215,0H53.358L74.344,21.081v63.7A15.215,15.215,0,0,1,59.129,100Z",
    fill: "#ee3e2c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.85,20.1H55A4.09,4.09,0,0,1,50.88,16V0",
    transform: "translate(3.494)",
    fill: "#fff",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.55,44.32a5.87,5.87,0,0,1,4.07,1.19,4.32,4.32,0,0,1,1.28,3.3,5.72,5.72,0,0,1-.29,1.81,4,4,0,0,1-.93,1.54A4.37,4.37,0,0,1,21,53.21a7.84,7.84,0,0,1-2.65.39H17v5.13H13.94V44.32Zm-.16,2.5H17V51.1h1a4.4,4.4,0,0,0,1.49-.23,1.94,1.94,0,0,0,1-.71,2.07,2.07,0,0,0,.34-1.24,2,2,0,0,0-.59-1.58,2.68,2.68,0,0,0-1.85-.52Z",
    transform: "translate(0.8 2.575)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.61,51.39a8.08,8.08,0,0,1-.93,4.06A5.87,5.87,0,0,1,38,57.91a10,10,0,0,1-4.25.82h-4.1V44.32h4.52a8.91,8.91,0,0,1,3.94.8,5.89,5.89,0,0,1,2.58,2.38,7.59,7.59,0,0,1,.92,3.89Zm-3.18.07A6.38,6.38,0,0,0,38,48.84a3.2,3.2,0,0,0-1.39-1.53,4.74,4.74,0,0,0-2.25-.49H32.71v9.39H34A4.25,4.25,0,0,0,37.34,55a5.06,5.06,0,0,0,1.09-3.54Z",
    transform: "translate(1.759 2.575)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.63,58.73h-3V44.32H55.9v2.5H50.63v3.72h4.89V53H50.63Z",
    transform: "translate(2.659 2.575)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf-file.199f9e5d8ae742b4d0b01ad9414924f4.svg";
export { ForwardRef as ReactComponent };